import type * as FormModelType from "@/components/features/settings/payment-credit/model/type";

export const paymentCreditInputModelFactory = (hotelID: string): FormModelType.PaymentCreditFormModel["InputModel"] =>
	({
		hotelID,
		hasPayjpValidation: true,
	}) satisfies FormModelType.PaymentCreditFormModel["InputModel"];
